async function axiosFetch(axios, input, init = {}) {
    const rawHeaders = init.headers || {};
    const lowerCasedHeaders = Object.keys(rawHeaders)
        .filter((key) => key && rawHeaders[key])
        .reduce((acc, key) => {
        acc[key.toLowerCase()] = rawHeaders[key];
        return acc;
    }, {});
    if (!("content-type" in lowerCasedHeaders)) {
        lowerCasedHeaders["content-type"] = "text/plain;charset=UTF-8";
    }
    const config = {
        url: input instanceof Request ? input.url : input,
        method: init.method || "GET",
        headers: lowerCasedHeaders,
        validateStatus: () => true,
    };
    if (init.body) {
        config.data = String(init.body);
    }
    const result = await axios.request(config);
    const responseBody = typeof result.data === `object` ? JSON.stringify(result.data) : result.data;
    const headersInit = {};
    Object.entries(result.headers).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            headersInit[key] = value.join(", ");
        }
        else {
            headersInit[key] = value;
        }
    });
    const headers = new Headers(headersInit);
    return new Response(responseBody, {
        status: result.status,
        statusText: result.statusText,
        headers,
    });
}
export function buildAxiosFetch(axios) {
    return axiosFetch.bind(undefined, axios);
}
//# sourceMappingURL=axios-fetch.js.map